import { render } from "./Spinner.vue?vue&type=template&id=41e04b01&ts=true"
import script from "./Spinner.vue?vue&type=script&lang=ts"
export * from "./Spinner.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/apps/myparcel4you-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__